import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import { Button, Collapse } from 'reactstrap';
import NumberFormat from 'react-number-format';
import GoogleTagManager from './GoogleTagManager';
import { VehicleSearchFilters } from './VehicleSearchFilters';
import { ResetFiltersButton } from './ResetFiltersButton';
import { PrimaryBannerButton } from './PrimaryBannerButton';

import '../custom.css';
import './Home.css';
import './Vehicle.css';
import './Content.css';

import smallSearch from '../images/icon-search.svg';
import arrowBackBig from '../images/arrow-back-big.svg';
import arrowBackSmall from '../images/arrow-back-small.svg';

// Fallback car images
import carImageCitigo from '../images/cars/citigo.png';
import carImageFabia from '../images/cars/fabia.png';
import carImageKaroq from '../images/cars/karoq.png';
import carImageKamiq from '../images/cars/kamiq.png';
import carImageKodiaq from '../images/cars/kodiaq.png';
import carImageOctavia from '../images/cars/octavia.png';
import carImageScala from '../images/cars/scala.png';
import carImageSuperb from '../images/cars/superb.png';
import carImageRapid from '../images/cars/rapid.png';
import carImageEnyaq from '../images/cars/enyaq.png';
import carImageElroq from '../images/cars/elroq.png';

//import demoCar from '../images/demovehicle/skoda-superb-black-edition-black.jpg';

export class Content extends Component {
    static displayName = Content.name;

    constructor(props) {
        super(props);

        let vehicleSearchFilters = JSON.parse(sessionStorage.getItem('session_vehicleSearchFilterValues'));
        let vehicleSearchResult = JSON.parse(sessionStorage.getItem('session_vehicleSearchResult'));

        this.state = {
            vehicleSearchResult: vehicleSearchResult,
            vehicleSearchFilterValues: vehicleSearchFilters,
            isSearchFiltersOpen: false,
            dropdownOpenModelName: false,
            dropdownOpenLocation: false,
            setDropdownOpen: false,
            isMoreOpen: false,
            fallbackCarImages: {
                "Citigo": carImageCitigo,
                "Fabia": carImageFabia,
                "Karoq": carImageKaroq,
                "Kamiq": carImageKamiq,
                "Kodiaq": carImageKodiaq,
                "Octavia": carImageOctavia,
                "Scala": carImageScala,
                "Superb": carImageSuperb,
                "Rapid": carImageRapid,
                "Enyaq": carImageEnyaq,
                "Elroq": carImageElroq
            }
        };

        this.toggleSearchFilters = this.toggleSearchFilters.bind(this);
    }

    toggleSearchFilters(event) {
        this.setState({
            isSearchFiltersOpen: !this.state.isSearchFiltersOpen
        });
    }

    renderVehicles(vehicleSearchResult) {
        let max = 0;
        if (vehicleSearchResult && (vehicleSearchResult.length > 0)) {
            max = vehicleSearchResult[0].totalResultCount < 6 ? vehicleSearchResult[0].totalResultCount : 6;
        }

        if (!max) {
            return "";
        }

        return (
            vehicleSearchResult[0].inventoryVehicles.slice(0, max).map((vehicle, i) =>
                <Col xs='12' sm='12' md='12' lg xl key={vehicle.id}>
                    <div className="search-result-car">
                        <Link to={{
                            pathname: "/vehicleinfo", search: "?id=" + vehicle.id,
                            state: {
                                vehicleSearchResult: this.state.vehicleSearchResult,
                                vehicleSearchFilterValues: JSON.stringify(this.state.vehicleSearchFilterValues)
                            }
                        }}>
                            <img src={vehicle.images.marketingImageUrls.length ? vehicle.images.marketingImageUrls[0].replace(".jpg", "_220.jpg").replace(".JPG", "_220.JPG") : this.state.fallbackCarImages[vehicle.modelName]} alt={vehicle.makeName + ' rek.nro. ' + vehicle.formattedLicensePlateNumber} className="search-result-car-img other-vehicles-img" onError={(e) => { e.target.onerror = null; e.target.src = this.state.fallbackCarImages[vehicle.modelName] }} />
                            <p className="search-result-car-model">{vehicle.modelName} {vehicle.modelType}</p>
                            <p className="search-result-car-info">{vehicle.modelYear} | {vehicle.kilometrage} 000 km</p>
                            <p className="search-result-car-price">
                                <NumberFormat value={vehicle.askPrice} displayType={'text'} thousandSeparator={' '} /> &euro;</p>
                        </Link>
                    </div>
                </Col>
            ));
    }

    render() {

        let searchResultCount = 0;
        if (this.state.vehicleSearchResult && this.state.vehicleSearchResult.length > 0) {
            searchResultCount = this.state.vehicleSearchResult[0].totalResultCount;
        }

        let bannerClassName = "vehicle-page-banner";
        if (window.supportsWebp === false) {
            bannerClassName = "vehicle-page-banner-no-webp";
        }


        let othervehicles = this.renderVehicles(this.state.vehicleSearchResult);
        const event = { platform: 'react-stack' }
        return (
            <Container>
                {/*<GoogleTagManager gtmId='GTM-5KVJGP3' scriptId='gtm-script-container' dataLayerName='content' additionalEvents={event} previewVariables='' />*/}
                <div className={bannerClassName}>
                    <Row>
                        <Col xs='0' sm='0' md='0' lg='10' xl='10'>
                            <div className="vehicle-page-bannerTextArea">
                                <p className="bannerTitle">Loisto</p>
                                <p className="bannerText">Vaihtoautojen valioyksilöt</p>
                            </div>
                        </Col>
                    </Row>
                </div>

                <Row>
                    <Col className="quick-search" xs='12' sm='12' md='12' lg='3'>
                        <div className='quick-search-heading-area'>
                            <Button id="btn-collapse-open-searchfilters"
                                className="quick-search-heading pt-4"
                                onClick={this.toggleSearchFilters}>
                                <img src={smallSearch} alt="Hae" />Pikahakukriteerit</Button>
                        </div>

                        <div className='quick-search-result pl-4 pt-2 pb-2'>
                            L&ouml;ytyi <strong>{searchResultCount}</strong> Loisto-autoa
                        </div>

                        <Route render={({ history }) => (
                            <ResetFiltersButton
                                history={history} />
                        )} />

                        <Collapse isOpen={this.state.isSearchFiltersOpen}>

                            <Route render={({ history }) => (
                                <VehicleSearchFilters
                                    history={history}
                                    currentVehicleSearchFilterValues={JSON.stringify(this.state.vehicleSearchFilterValues)} />
                            )} />

                            <Button id="btn-collapse-close-searchfilters"
                                className="search-form-btn-collapse-close mr-4"
                                onClick={this.toggleSearchFilters}>Sulje hakukriteerit</Button>
                        </Collapse>

                        <div className="d-none d-lg-block">
                            {othervehicles}
                            <div className="left-column-back ml-5 mt-5 mr-2 mb-2">
                                <Link to={{
                                    pathname: "/",
                                    state: {
                                        vehicleSearchFilterValues: JSON.stringify(this.state.vehicleSearchFilterValues)
                                    }
                                }}>
                                    <img src={arrowBackBig} alt="Back" className="mr-4 pt-2"></img>
                                    <span>Loisto-vaihtoautojen valioyksilöt</span>
                                </Link>
                            </div>
                        </div>
                    </Col>

                    <Col xs='0' sm='0' md='0' lg='9'>
                        <div className="content-area">
                            <Row>
                                <Col xs='12' sm='12' md='12' lg='12' xl='12'>
                                    <div className="content-area-back pt-4">
                                        <Link to={{
                                            pathname: "/",
                                            state: {
                                                vehicleSearchFilterValues: JSON.stringify(this.state.vehicleSearchFilterValues)
                                            }
                                        }}>
                                            <img src={arrowBackSmall} alt="Back" className="mr-2 mb-1"></img>
                                            Loisto - vaihtoautojen valioyksilöt
                                        </Link>
                                    </div>

                                    <h2 className="loisto-content-h2">Škodan Loisto -vaihtoautot kattavalla vaihtoautoturvalla</h2>
                                    <div className="text-content mb-3">
                                        Loisto on Škodan korkeatasoinen vaihtoauto-ohjelma, josta löydät parhaat ja valikoidut Škoda-vaihtoautot – halutessasi kattavalla vaihtoautoturvalla tai huolenpitosopimuksella varustettuna. Valikoimaamme päässeet Škoda-vaihtoautot ovat läpäisseet tiukat laatuvaatimukset: autot ovat alle 5-vuotiaita, ajettu enintään 130 000 kilometriä, huolellisesti kuntotarkastettuja ja aukottomalla huoltohistorialla varustettuja.
                                    </div>
                                    <div className="text-content mb-3">
                                        Jokaisen Loisto-vaihtoauton yhteyteen on saatavilla kattava lisäturva: <strong>Loisto-vaihtoautoturva</strong> tai <strong>Škoda Huoleton</strong> -huolenpitosopimus, joka suojaa sinua yllättäviltä kuluilta. Vaihtoautoturva kattaa auton tekniset viat ja rikkoutumiset jopa 12 tai 24 kuukauden ajan ostopäivästä lähtien – jotta voit keskittyä ajamisesta nauttimiseen. Škoda Huoleton sisältää tekniset korjaukset jopa auton 10 ikävuoteen tai 200 000 km saakka, kaikki määräaikaishuollot, normaalissa käytössä kuluvien osien vaihdon sekä katsastustarkastuksen ennen katsastusta.
                                    </div>

                                    <h2 className="loisto-content-h2">Miksi Škoda Loisto -vaihtoauto kannattaa?</h2>
                                    <div className="text-content mb-3">
                                        Käytetyn auton hankintaan voi liittyä monenlaisia riskejä. Millaisessa kunnossa auto todellisuudessa on? Entä jos siihen tulee yllättäviä vikoja?
                                    </div>

                                    <h3 className="loisto-content-h3">Vaihtoautojen valioyksilöt</h3>
                                    <div className="text-content mb-3">
                                        Loisto on Škodan vaihtoauto-ohjelma, joka vähentää merkittävästi riskejä. Ohjelmaan pääsevät parhaat ja valikoidut Škoda-vaihtoautot. 
                                    </div>
                                    <div className="text-content mb-3">
                                        <ul className="loisto-content-ul">
                                            <li>Valittavissa maksullinen lisäturva oman tarpeen mukaan</li>
                                            <li>Alle 5-vuotiaita</li>
                                            <li>Merkkihuollettuja</li>
                                            <li>Kuntotarkastettuja</li>
                                            <li>Škoda Ajoturva</li>
                                            <li>Vaihto-oikeus</li>
                                            <li>Kotiin toimitus sovittaessa</li>
                                        </ul>
                                    </div>
                                    
                                    <h3 className="loisto-content-h3">Turvaa tien päälle</h3>
                                    <div className="text-content mb-3">
                                        Loisto-vaihtoautoissa on voimassa Škoda Ajoturva, joka tarjoaa 24 h tiepalvelun ja tarvittaessa autosi hinauksen sekä sinun ja matkaseurueesi kuljetuksen pois vikapaikalta, mikäli autosi kuntoon saattaminen vaatisikin korjaamotoimenpiteitä. Teknisen vian tai rikkoutumisen sattuessa Škoda Ajoturva tarjoaa sinulle sijaisauton Ajoturvan ehtojen mukaisesti, mikäli autoasi ei saada saman päivän aikana kuntoon. Škoda Škoda Ajoturva on voimassa aina koko huoltovälin ajan, kun autosi on huollettu ja muut toimenpiteet on suoritettu valtuutetussa Škoda Service -merkkihuollossa ja huoltokirjassa tai huoltotulosteessa on voimassa oleva Škoda Ajoturva-leima. <a className="text-skoda-green" href="https://www.skoda.fi/palvelut-omistajalle/skoda-ajoturva" target="_blank" rel="noopener noreferrer">Lue lisää Škoda Ajoturvasta</a>.
                                    </div>

                                    <h3 className="loisto-content-h3">Vaihto-oikeus</h3>
                                    <div className="text-content mb-3">
                                        Sinulla on mahdollisuus vaihtaa autosi toiseen Škoda-merkkiseen vaihtoautoon 14 vuorokauden tai 1000 km kuluttua auton ostohetkestä, jos jostain syystä tuletkin toisiin aatoksiin uuden Loisto-vaihtoturvallisen autosi kanssa.
                                    </div>
                                    
                                    <h3 className="loisto-content-h3">Kotiinkuljetus</h3>
                                    <div className="text-content mb-3">
                                        Halutessasi auto toimitetaan kaupanteon jälkeen suoraan kotiosoitteeseesi. Kysy lisää kotiinkuljetuksesta ja siihen liittyvistä kustannuksista Škoda-jälleenmyyjältäsi.
                                    </div>

                                    <h2 className="loisto-content-h2">Paljon vai erittäin paljon turvaa?</h2>
                                    <div className="text-content mb-3">
                                        Haluatko lisää turvaa Loisto-vaihtoautoosi? Nukkua yösi hyvin tarvitsematta pelätä yllättäviä korjauskuluja? Maksullisista lisäturvapaketeista voit valita omia tarpeitasi vastaavan vaihtoehdin, jotka turvaavat teknisistä vioista johtuvat korjaukset – ja halutessasi paljon, paljon enemmän.
                                    </div>
                                    
                                    <h2 className="loisto-content-h2">Tutustu lisäturvapaketteihin</h2>
                                    <div className="text-content mb-3">
                                        <div className="container my-5">
                                            <div className="table-responsive">
                                            <table className="table comparison-table mb-0">
                                                <thead>
                                                <tr>
                                                    <th>Valinnainen lisäturva</th>
                                                    <th>Loisto 12</th>
                                                    <th>Loisto 24</th>
                                                    <th>Škoda Huoleton</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>Škoda Ajoturva käyttäessäsi Škoda Service -merkkihuoltoa</td>
                                                    <td className="x">X</td>
                                                    <td className="x">X</td>
                                                    <td className="x">X</td>
                                                </tr>

                                                <tr>
                                                    <td>Tekniset korjaukset 12 kk tai 20 000 km asti</td>
                                                    <td className="x">X</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>

                                                <tr>
                                                    <td>Tekniset korjaukset 24 kk tai 40 000 km asti</td>
                                                    <td></td>
                                                    <td className="x">X</td>
                                                    <td></td>
                                                </tr>

                                                <tr>
                                                    <td>Tekniset korjaukset jopa 10 v tai 200 000 km asti</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td className="x">X</td>
                                                </tr>

                                                <tr>
                                                    <td>Määräaikaishuollot; tarkastus- ja öljynvaihtohuollot</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td className="x">X</td>
                                                </tr>

                                                <tr>
                                                    <td>Normaalissa käytössä kuluvien osien vaihto</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td className="x">X</td>
                                                </tr>

                                                <tr>
                                                    <td>Sijaisauto korjauksen ajaksi max. 2 vrk</td>
                                                    <td className="x">X</td>
                                                    <td className="x">X</td>
                                                    <td></td>
                                                </tr>

                                                <tr>
                                                    <td>Sijaisauto huollon tai korjauksen ajaksi max. 2 vrk (maksullinen lisäpalvelu)</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td className="x">X</td>
                                                </tr>

                                                <tr>
                                                    <td>Katsastustarkastus kun auton katsastus on ajankohtainen</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td className="x">X</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                    </div>

                                    <br />

                                    <h3 className="loisto-content-h3">Škoda Loisto -vaihtoautoturvan hinnat</h3>
                                    <div className="text-content mb-3">
                                        12 kk / 20 000 km <strong>590 €</strong>
                                        <br />24 kk / 40 000 km <strong>1 180 €</strong>
                                    </div>

                                    <h3 className="loisto-content-h3">Škoda Huoleton -huolenpitosopimus</h3>
                                    <div className="text-content mb-3">
                                        Aloitusmaksu alkaen 690 € + kk-veloitus mallikohtaisesti.
                                    </div>
                                    <div className="text-content mb-3">
                                        Tarkemmat tiedot löydät Škoda Huolenpitosopimuksen- sekä Škoda Loisto -vaihtoautoturvan ehdoista. Huollattamalla autosi ajallaan Škoda Service -merkkihuollossa varmistat, että palvelut pysyvät voimassa. Kysy lisää omalta Škoda-jälleenmyyjältäsi.
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>

            </Container>
        );
    }
}